"use client";
import { jsx as e } from "react/jsx-runtime";
import { forwardRef as c, useMemo as p } from "react";
import { ICON_COMPONENTS as s } from "./map.js";
const i = c(
  (t, o) => {
    const { icon: n, ...r } = t;
    return p(() => {
      const m = s[n];
      return /* @__PURE__ */ e(m, { ref: o, ...r });
    }, [n, o, r]);
  }
);
i.displayName = "IconSVG";
export {
  i as IconSVG
};
